import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aa58b868"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "mini-share-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "微信扫码进入对应小程序的活动页，再点击“分享给好友或微信群”。接收者也可以继续分享。", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 2,
  class: "share-error",
  role: "status"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "share-hint" }, "分享不转移他人的持券资格，优惠以本人券列表及结算结果为准。", -1))

import {computed,onBeforeUnmount,ref,watch} from 'vue'
import store from '@/store'
import request from '@/utils/request'

export default /*#__PURE__*/_defineComponent({
  __name: 'CouponMiniShare',
  props: {
    kind: null,
    shareId: null,
    title: null
  },
  setup(__props: any) {

const props = __props as {kind:'campaign'|'coupon';shareId:number|string;title?:string};


const visible=ref(false),loading=ref(false),image=ref(''),error=ref(''),displayTitle=ref('')
let serial=0,abort:AbortController|undefined
const scope=computed(()=>JSON.stringify([store.getters.orgId,store.getters.orgInfo?.id]))
function clear(){serial++;abort?.abort();abort=undefined;if(image.value)URL.revokeObjectURL(image.value);image.value='';loading.value=false}
watch(()=>[scope.value,props.kind,props.shareId],()=>{visible.value=false;clear()})
watch(visible,value=>{if(!value)clear()});onBeforeUnmount(clear)
async function open(){
  clear();const current=serial,orgId=Number(store.getters.orgId),identity=scope.value,id=Number(props.shareId)
  visible.value=true;error.value='';displayTitle.value=''
  if(!Number.isSafeInteger(id)||id<1||orgId<1000||Number(store.getters.orgInfo?.id)!==orgId){error.value='店铺或活动尚未验证，请重试。';return}
  loading.value=true
  try{
    const response=await request({url:'fsystem/couponShare',method:'GET',params:{orgId,kind:props.kind,id}})
    if(current!==serial || identity!==scope.value)return
    const value=response.data
    if(!value?.available || Number(value.orgId)!==orgId || value.kind!==props.kind || Number(value.shareId)!==id)throw Error('活动或优惠券已结束、停用或不可分享。')
    displayTitle.value=value.title
    const query=new URLSearchParams({path:'pages-system-shareActivity',param:'orgId-'+orgId+'and'+(props.kind==='campaign'?'c':'k')+'-'+id,orgId:String(orgId),clientType:orgId===1000?'platform':'branch'})
    const base=String(process.env.VUE_APP_BASE_API || '/').replace(/\/?$/,'/')
    const controller=new AbortController();abort=controller;const timer=setTimeout(()=>controller.abort(),20000)
    let result:Response
    try{result=await fetch(base+'land/appletQrCode?'+query,{signal:controller.signal})}finally{clearTimeout(timer)}
    if(!result.ok)throw Error('小程序码暂未生成，请稍后重试。')
    const blob=await result.blob()
    if(!blob.type.startsWith('image/') || blob.size===0)throw Error('小程序码尚不可用，请核对小程序版本及接口。')
    if(current!==serial || identity!==scope.value)return
    image.value=URL.createObjectURL(blob)
  }catch(e:any){if(current===serial)error.value=e?.message || '分享入口准备失败，请重试。'}
  finally{if(current===serial)loading.value=false}
}

return (_ctx: any,_cache: any) => {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (Number(__props.shareId)>0)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "coupon-share-button",
          type: "button",
          onClick: _withModifiers(open, ["stop"])
        }, _toDisplayString(__props.kind==='campaign'?'分享活动':'分享优惠券'), 9, _hoisted_1))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
      title: "分享到微信好友或微信群",
      footer: null,
      width: 420,
      onCancel: clear
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("strong", null, _toDisplayString(displayTitle.value || __props.title), 1),
          _hoisted_3,
          (loading.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, "正在准备小程序码…"))
            : (image.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: image.value,
                  alt: "当前活动的小程序码",
                  width: "240",
                  height: "240"
                }, null, 8, _hoisted_5))
              : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(error.value), 1)),
          (image.value)
            ? (_openBlock(), _createElementBlock("a", {
                key: 3,
                href: image.value,
                download: "活动小程序码.png"
              }, "保存小程序码", 8, _hoisted_7))
            : _createCommentVNode("", true),
          _hoisted_8
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})